import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { PostalAddress } from './model';
import { ValidationErrorView } from 'core/validationerror/view';

export const PostalAddressView = SuperCritical(({ model: m } : { model : PostalAddress }) =>
    <div className="postaladdress">
        <div className="address-details">
            <span className="pc-input-viewcontrol address pc-text-fixedwidth">
                {m.Model.Address()}
            </span>
            <input className="pc-input-editcontrol address"
                type="text"
                placeholder="Street Address"
                value={m.Model.Address()}
                onChange={e => m.Model.Address((e.target as HTMLInputElement).value)} />
            {' '}
            <span className="pc-input-viewcontrol apt pc-text-fixedwidth">
                {m.Model.AptSte()}
            </span>
            <input className="pc-input-editcontrol apt"
                type="text"
                placeholder="Apt./Ste."
                value={m.Model.AptSte() || ''}
                onChange={e => m.Model.AptSte((e.target as HTMLInputElement).value)} />
            <br />
            <span className="pc-input-viewcontrol city pc-text-fixedwidth">
                {m.Model.City() ? m.Model.City() + ',' : ''}
            </span>
            <input className="pc-input-editcontrol city"
                type="text"
                placeholder="City"
                value={m.Model.City()}
                onChange={e => m.Model.City((e.target as HTMLInputElement).value)} />
            {' '}
            <span className="pc-input-viewcontrol state pc-text-fixedwidth">
                {m.Model.StateProv()}
            </span>
            <input className="pc-input-editcontrol state"
                type="text"
                placeholder="State/Province"
                value={m.Model.StateProv()}
                onChange={e => m.Model.StateProv((e.target as HTMLInputElement).value)} />
            {' '}
            <span className="pc-input-viewcontrol zip pc-text-fixedwidth">
                {m.Model.PostalCode()}
            </span>
            <input className="pc-input-editcontrol zip"
                type="text"
                placeholder="Postal Code"
                value={m.Model.PostalCode()}
                onChange={e => m.Model.PostalCode((e.target as HTMLInputElement).value)} />
            {/* TODO: add country code select */}
        </div>
        {m.CanDelete &&
            <a href="" className="delete pc-input-editcontrol" onClick={noDefault(m.Delete)}>
                <i className="pc-close-icon"></i>
            </a>
        }
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/postaladdress/view.tsx